<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="primary-box">
        <a-form :form="form" class="search-all-box">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="标题：">
                <a-input class="search-input" v-decorator="rules.title" placeholder="请输入标题" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="标签：">
                <TagsInput class="tags-parent" v-decorator="rules.tags" :tags="tagsValue" @changed="tagsChanged"></TagsInput>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="团队成员：">
                <a-input class="search-input" v-decorator="rules.work_members" placeholder="请输入团队成员" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="指导教师：">
                <a-input class="search-input" v-decorator="rules.teachers" placeholder="请输入指导教师" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="实践基地：">
                <a-input class="search-input" v-decorator="rules.hub" placeholder="请输入实践基地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :required="true" :wrapper-col="formItemLayout.wrapperCol" label="封面上传：">
                <a-upload name="file" v-decorator="rules.cover" :customRequest="handleUpload" :multiple="true" :showUploadList="false" accept=".png,.jpeg,.jpg" class="file-upload">
                  <div class="file-handle">
                    <div class="upload-btn" @click="uploadType = 1">本地上传</div>
                  </div>
                </a-upload>
                <div class="upload-text">最大支持10M，仅支持.png、.jpg、.jpeg格式的文件（图片比例建议16:9）</div>
                <!-- 文件列表 -->
                <div class="file-list" v-if="coverImg">
                  <!-- 图片、音频类型不需要显示转码状态   covert_status 转码 1 2 3 进行中 已完成 上传中-->
                  <div :class="['file-item',coverImg.status == 'uploading'?'uploading':'']">
                    <div class="file-upper">
                      <!-- 文件封面 docx显示默认封面 -->
                      <div class="file-cover" :style="`background:url(${coverImg.cover||coverImg.view_url}) no-repeat center/cover`">
                      </div>
                      <!-- 删除附件 disabled -->
                      <div class="file-delete" @click="removeCoverFile"></div>
                      <div class="file-mask">
                        <!-- 上传进度 -->
                        <div class="file-progress" v-if="coverImg.status == 'uploading'">
                          <a-progress type="circle" :percent="coverImg.progress" :width="40" strokeColor="#B84B3C" trailColor="#E3E4E9" />
                        </div>
                        <div class="file-button">
                          <!-- 预览 -->
                          <div class="file-preview" @click="previewRes(coverImg)">预览</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :required="true" :wrapper-col="formItemLayout.wrapperCol" label="视频上传：">
                <a-upload name="file" v-decorator="rules.cases_attachments" :customRequest="handleUpload" :multiple="true" :showUploadList="false" accept=".mp4,.mov" class="file-upload">
                  <div class="file-handle">
                    <a-button class="upload-btn" type="button" @click="uploadType = 2">上传视频</a-button>
                  </div>
                </a-upload>
                <div class="upload-text">最大支持2G的文件，仅支持.mp4、.mov格式</div>
                <!-- 文件列表 -->
                <div class="file-list" v-if="fileList&&fileList.length > 0">
                  <!-- 图片、音频类型不需要显示转码状态   covert_status 转码 1 2 3 进行中 已完成 上传中-->
                  <div v-for="(file, index) in fileList" :key="index" :class="['file-item',file.type == 3&&file.covert_status == 2?'translate':'',file.status == 'uploading'?'uploading':'']">
                    <div class="file-upper">
                      <!-- 文件封面 docx显示默认封面 -->
                      <div class="file-cover" :style="(file.type == 3 && file.covert_status == 2) ? `background:url(${file.cover||file.view_url}) no-repeat center/cover` : ''">
                      </div>
                      <!-- 删除附件 -->
                      <div class="file-delete" @click="removeVideoFile(index)"></div>
                      <div class="file-mask">
                        <!-- 上传进度 -->
                        <div class="file-progress" v-if="file.status == 'uploading'">
                          <a-progress type="circle" :percent="file.progress" :width="40" strokeColor="#B84B3C" trailColor="#E3E4E9" />
                        </div>
                        <div class="file-button" v-else-if="( file.covert_status == 2)">
                          <div class="file-preview" @click="previewRes(file)">预览</div>
                        </div>
                      </div>

                      <!-- 转码中 如果状态不是在上传中 & 附件不是图片、音频 & 不是转码中-->
                      <template v-if="(file.status != 'uploading') && file.type != 1 && file.type != 2">
                        <div v-if="file.covert_status == 1" :class="['file-translate',file.translate?'translate':'']"></div>
                        <div v-else-if="file.covert_status == 3" class="file-translate transerror"></div>
                      </template>
                    </div>
                    <!-- 附件名称 -->
                    <div class="file-name">
                      <a-popover v-if="file.filename&&file.filename.length > 28" placement="bottom">
                        <template slot="content">
                          <div>{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
                        </template>
                        <div class="name-txt">{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
                      </a-popover>
                      <div v-else class="name-txt">{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
                    </div>
                  </div>
                </div>

              </a-form-item>
            </a-col>
          </a-row>

          <a-row v-if="cases_id" :gutter="24">
            <a-col :span="12">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="排序：">
                <a-input-number style="width: 220px" class="search-input" id="inputNumber" v-decorator="rules.sort" :step="1" :min="0" placeholder="请输入排序" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item :label-col="{ span: 2 }" :required="true" :wrapper-col="{ span: 22 }" label="正文：">
                <div v-decorator="rules.content">
                  <qEditor :valuetxt="editorCon" @inputChange="changeContent"></qEditor>
                </div>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="24">
              <div class="group-box">
                <div class="btn-item cancel" @click="cancelEevent">取 消</div>
                <div class="btn-item submit" @click="submitForm">提 交</div>
                <div class="btn-item preview" @click="previewCase">预 览</div>
              </div>
            </a-col>
          </a-row>

        </a-form>
      </div>
    </div>

    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>
    <CommonModal v-model="showModal" :title="modalTitle" :showCancel="false" @cancel="cancelShowModal" :showConfirm="false">
      <div class="case-content-box">
        <div class="review-tabs">
          <div :class="['tabs-item', reviewTab == 'pc' ? 'active' :'']" @click="reviewTab = 'pc'">网页端</div>
          <div :class="['tabs-item', reviewTab == 'h5' ? 'active' :'']" @click="reviewTab = 'h5'">手机端</div>
        </div>
        <div v-if="previewObj" class="right-all-box">
          <div v-show="reviewTab == 'pc'" class="platform-pc">
            <div class="case-title">{{previewObj.title}}</div>
            <div class="case-info">
              <div class="info-label">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签：</div>
              <div class="info-con">
                <span v-for="item,index in tagsValue" :key="index">{{item.name}}</span>
              </div>
            </div>
            <div class="case-info">
              <div class="info-label">指导教师：</div>
              <div class="info-con">{{previewObj.teachers}}</div>
            </div>
            <div class="case-info">
              <div class="info-label">团队成员：</div>
              <div class="info-con">{{previewObj.work_members}}</div>
            </div>
            <div v-if="showModal" id="jeol-caseVideo-pc" class="case-video-box">
              <div v-for="item,index in previewObj.cases_attachments" :key="index" class="video-items">
                <video v-if="item.covert_status == 2" :id="`player-pc-${index}`" playsinline webkit-playsinline></video>
                <div v-else-if="item.covert_status == 3" class="trans-cover">
                  <img src="../../../assets/image/student/unitTwo/transerror.jpg" alt="" />
                </div>
                <div v-else class="trans-cover">
                  <img src="../../../assets/image/student/unitTwo/translate.png" alt="" />
                </div>
              </div>
            </div>
            <div class="content-txt ql-editor" v-html="previewObj.content"></div>

          </div>

          <div v-show="reviewTab == 'h5'" class="outer-h5">
            <div class="platform-h5">
              <div class="h5-scroll">
                <div class="case-title">{{previewObj.title}}</div>
                <div class="case-info">
                  <div class="info-label">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签：</div>
                  <div class="info-con"><span v-for="item,index in tagsValue" :key="index">{{item.name}}</span></div>
                </div>
                <div class="case-info">
                  <div class="info-label">指导教师：</div>
                  <div class="info-con">{{previewObj.teachers}}</div>
                </div>
                <div class="case-info">
                  <div class="info-label">团队成员：</div>
                  <div class="info-con">{{previewObj.work_members}}</div>
                </div>
                <div v-if="showModal" id="jeol-caseVideo-h5" class="case-video-box">
                  <div v-for="item,index in previewObj.cases_attachments" :key="index" class="video-items">
                    <video v-if="item.covert_status == 2" :id="`player-h5-${index}`" playsinline webkit-playsinline></video>
                    <div v-else-if="item.covert_status == 3" class="trans-cover">
                      <img src="../../../assets/image/student/unitTwo/transerror.jpg" alt="" />
                    </div>
                    <div v-else class="trans-cover">
                      <img src="../../../assets/image/student/unitTwo/translate.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="content-txt ql-editor" v-html="previewObj.content"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </CommonModal>

    <!-- 确认提交框 -->
    <CommonModal v-model="submitVisible" title="提交案例" confirmText="确定" @confirm="submitCases">
      <div>
        确定提交吗？
      </div>
    </CommonModal>

    <!-- 上传文件异常提示 -->
    <CommonModal v-model="uploadErrorVisible" title="文件异常提示" :showCancel="false" :showConfirm="false" confirmText="确定">
      <div>
        <div style="text-align: center;color: #A82822;font-size: 30px;margin: 0 0 10px;"><a-icon type="exclamation-circle" /></div>
        平台检测到该文件存在异常，请检查后重新上传。
      </div>
    </CommonModal>

    <a-spin :spinning="isRequest" tip="提交中">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const formTailLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 9, },
};
import services from '../../../assets/js/services';
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { mapActions } from "vuex";
import Bread from "../../../components/school/Bread.vue";
import CommonModal from "../../../components/CommonModal"
import TcVod from 'vod-js-sdk-v6';//腾讯云上传视频和转码
import qEditor from '../../../components/QuillEditor.vue'
import TagsInput from '../../../components/TagsInput.vue'
export default {
  data () {
    return {
      breadConfig: [
        { name: "案例台账" },
        { name: "案例推优" },
      ],
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      services,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      editorCon: '', // 编辑器内容
      showModal: false,
      modalTitle: '',
      uploadType: 1,
      coverImg: null, // 封面图片
      fileList: [],  // 上传视频的列表
      chunkSize: 5 * 1024 * 1024, // 分片大小 5MB
      limitSize: 1024 * 1024 * 1024, // 最大上传1G
      limitText: "1G",// 超出限制提示文本
      reviewTab: 'pc',
      task_id: "t007", // 创实践微影 名称
      work_id: undefined, // 作业id
      activity_id: undefined, // 活动id
      cases_id: undefined, // 案例id
      submitVisible: false,
      uploadErrorVisible: false,
      workDetail: null, // 作业详情
      tagsValue: [],
      isRequest: false,
      previewObj: null,
      rules: {
        title: [
          "title",
          {
            validateTrigger: "blur",
            rules: [
              { required: true, whitespace: true, message: "请输入标题" },
              { min: 2, whitespace: true, message: "标题最少输入2个字符" },
              { max: 100, whitespace: true, message: "标题不能超过100个字符", },
            ],
          },
        ],
        tags: [
          "tags",
          {
            rules: [{ required: true, message: "请添加标签" }],
          },
        ],
        work_members: [
          "work_members",
          {
            validateTrigger: "blur",
            rules: [
              { required: true, whitespace: true, message: "请输入团队成员" },
            ],
          },
        ],
        teachers: [
          "teachers",
          {
            validateTrigger: "blur",
            rules: [
              { required: true, whitespace: true, message: "请输入指导教师" },
            ],
          },
        ],
        hub: [
          "hub",
          {
            validateTrigger: "blur",
            rules: [{ whitespace: true, message: "请选择标签" }],
          },
        ],
        cover: [
          "cover",
          {
            rules: [{ required: true, message: "请上传封面图片" }],
          },
        ],
        cases_attachments: [
          "cases_attachments",
          {
            rules: [{ required: true, message: "请上传视频" }],
          },
        ],
        content: [
          "content",
          {
            rules: [{ required: true, message: "请输入正文" }],
          },
        ],
        sort: [
          "sort",
          {
            rules: [{ required: true, message: "请输入排序" }],
          },
        ],
      },
      school_code: localStorage.getItem("schoolCode")
    };
  },
  components: {
    PreviewPdf: () => import('../../../components/PreviewPdf'),
    PlayBox: () => import('../../../components/PlayBox'),
    Bread, CommonModal, qEditor, TagsInput
  },
  // computed: {
  //   ...mapState({
  //     workDetail: state => state.teachEvent.workDetail,
  //   }),
  // },
  async mounted () {
    if (this.$route.query.id) {
      this.activity_id = this.$route.query.id
    }
    if (this.$route.query.work_id) {
      this.work_id = this.$route.query.work_id
    }
    if (this.$route.query.cases_id) {
      this.cases_id = this.$route.query.cases_id
    }

    if (this.cases_id) {
      // 编辑优秀案例 - 获取案例详情
      await this.getCasesDetails()
    } else {
      // 创建优秀案例 - 获取作业详情
      await this.getWorkDetails()
    }


    this.$nextTick(() => {
      this.initTcVod();
    })
  },
  methods: {
    ...mapActions(["getWorkDetail", 'getCasesExcellentDetails']),
    // 富文本内容change事件
    changeContent (con) {
      this.form.setFieldsValue({ content: con })
    },
    // 标签改变事件
    tagsChanged (arr) {
      let alltag = []
      for (let i = 0; i < arr.length; i++) {
        alltag.push(arr[i].name)
      }
      this.form.setFieldsValue({ tags: alltag.join(",") })
    },
    // 编辑优秀案例 - 获取案例详情
    async getCasesDetails () {
      let that = this
      await this.getCasesExcellentDetails({ id: this.cases_id, }).then(res => {
        if (res.code == "0000" && res.data) {
          if (res.data.hub) {
            that.form.setFieldsValue({ hub: res.data.hub })
          }
          if (res.data.work_members) {
            that.form.setFieldsValue({ work_members: res.data.work_members })
          }
          if (res.data.teachers) {
            that.form.setFieldsValue({ teachers: res.data.teachers })
          }
          if (res.data.content) {
            that.form.setFieldsValue({ content: res.data.content })
            that.editorCon = res.data.content
          }
          if (res.data.title) {
            that.form.setFieldsValue({ title: res.data.title })
          }
          if (res.data.tags) {
            that.form.setFieldsValue({ tags: res.data.tags })
            let tagsarr = res.data.tags.split(",")
            for (var i = 0; i < tagsarr.length; i++) {
              that.tagsValue.push({
                id: i,
                name: tagsarr[i]
              })
            }
          }
          if (res.data.cover) {
            that.coverImg = {
              type: 1,
              covert_status: 2,// 默认转码未完成(图片类型不需要转码,默认转码成功)
              progress: 100, // 上传进度
              status: 'success', // 默认状态上传中
              view_url: res.data.cover,
              path: res.data.cover
            }
            that.form.setFieldsValue({ cover: res.data.cover })
          }

          that.form.setFieldsValue({ sort: res.data.sort })

          if (res.data.cases_attachments) { // is_upload 0附件资源，1上传资源
            that.fileList = res.data.cases_attachments.map((item, index) => {
              item.type = 3
              item.is_upload = 0
              item.fileTime = new Date().getTime() + index
              if (item.covert_status == 1) item.translate = true
              return item
            })
            that.form.setFieldsValue({ cases_attachments: that.fileList })

          }
        }
      })
    },
    // 创建案例 - 获取作业详情数据
    async getWorkDetails () {
      let that = this
      await this.getWorkDetail({ id: this.work_id, activity_id: this.activity_id, task_id: this.task_id, }).then(res => {
        if (res.code == "0000" && res.data) {
          if (res.data.hub) {
            that.form.setFieldsValue({ hub: res.data.hub })
          }
          if (res.data.member) {
            that.form.setFieldsValue({ work_members: res.data.member.map(item => item.name).join(", ") })
          }
          if (res.data.teacher) {
            that.form.setFieldsValue({ teachers: res.data.teacher.map(item => item.name).join(", ") })
          }
          if (res.data.attachment) { // is_upload 0附件资源，1上传资源
            that.fileList = res.data.attachment.filter((item, index) => {
              if (item.type == 3) {
                item.is_upload = 0
                item.fileTime = new Date().getTime() + index
                if (item.covert_status == 1) item.translate = true
                return item
              }
            })
            that.form.setFieldsValue({ cases_attachments: that.fileList })

          }
        }
      })
    },
    // 取消事件
    cancelEevent () {
      window.open(`/${this.school_code}/school/case/excellent`, "_self")
    },
    // 提交表单
    submitForm () {
      let that = this
      that.form.validateFields(async err => {
        if (!err) {
          if (that.coverImg && that.coverImg.status == 'uploading') return that.$message.info("请等待封面上传完成后再次提交")
          // 判断视频上传完成后再提交
          let isUploading = false
          for (let i = 0; i < that.fileList.length; i++) {
            if (that.fileList[i].status == 'uploading') {
              isUploading = true
              break;  // 找到目标值后退出循环
            }
          }
          if (isUploading) return that.$message.info("请等待视频上传完成后再次提交")

          that.submitVisible = true
        }
      });

    },
    // 提交表单
    submitCases () {
      let params = this.form.getFieldsValue()
      console.log("params", params)
      this.submitMethod(params)
    },
    // 提交案例请求
    submitMethod (formData) {
      let that = this
      if (that.isRequest) return this.$message.info("请等待提交完成后再次提交")
      that.isRequest = true
      let cases_attachments = JSON.stringify(that.fileList.map((item => {
        let data = {
          filename: item.filename,
          is_upload: item.is_upload,
        }
        if (item.id) data["id"] = item.id
        if (item.file_id) data["file_id"] = item.file_id
        if (item.type != 3) data["path"] = item.path
        return data
      })
      ))
      let params = {
        title: formData.title,
        tags: formData.tags,
        work_members: formData.work_members,
        teachers: formData.teachers,
        hub: formData.hub,
        cover: formData.cover,
        cases_attachments,
        content: formData.content,
      }
      if (that.cases_id) {
        params.sort = formData.sort
        params._method = 'put'
        // content 为富文本字符串，请求前对其中的 HTML 标签进行转义
        if (params.content && typeof params.content === 'string') {
          params.content = params.content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        }
        // 编辑案例
        services.putSchoolTrainCases({ id: that.cases_id, data: params }).then(result => {
          that.isRequest = false
          if (result.code == "0000") {
            that.$message.success("提交成功")
            that.cancelEevent()
          } else {
            that.$message.error(result.message)
          }
        }).catch(() => {
          that.isRequest = false
        })
      } else {
        // 创建案例
        params.work_id = that.work_id
          params.activity_id = that.activity_id
          // content 为富文本字符串，请求前对其中的 HTML 标签进行转义
          if (params.content && typeof params.content === 'string') {
            params.content = params.content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
          }
          services.postSchoolTrainCases(params).then(result => {
            that.isRequest = false
            if (result.code == "0000") {
              that.$message.success("提交成功")
              that.cancelEevent()
            } else {
              that.$message.error(result.message)
            }
          }).catch(() => {
            that.isRequest = false
          })
      }


    },

    // 腾讯云点播上传初始化
    initTcVod () {
      let that = this
      this.tcVods = new TcVod({
        getSignature: that.getTencentSign
      })
    },
    // 获取腾讯云点播签名
    async getTencentSign () {
      let result = await services.getTencentSign();
      return result.data.sign
    },
    // 上传封面及视频方法
    handleUpload ({ file }) {
      let that = this
      let type = that.getFileType(file.type)
      if (type == 3) { // 3视频
        that.limitSize = 2 * 1024 * 1024 * 1024
        that.limitText = "2G"
      } else {
        that.limitSize = 1024 * 1024 * 1024
        that.limitText = "1G"
        if (file.size == 0) {
          that.uploadErrorVisible = true
          return false
        }
      }
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的文件`)
      let fileTime = new Date().getTime()
      let param = {
        fileTime,
        filename: file.name, // 附件名称
        type, // 附件类型
        covert_status: type == 1 ? 2 : 1,// 默认转码未完成(图片类型不需要转码,默认转码成功)
        progress: 0, // 上传进度
        status: 'uploading', // 默认状态上传中
        view_url: type == 1 ? URL.createObjectURL(file) : "",
        is_upload: 1
      }
      if (type == 1) {
        that.coverImg = param
      } else {
        // 加入附件列表
        that.fileList.push(param)
      }

      // 视频通过腾讯云点播上传
      if (type == 3) return this.handleVideoUpload(file, fileTime)

      // 其他类型上传
      const chunkSize = 1024 * 1024 * 3; // 3MB
      const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
      const uuid = uuidv4() // 文件唯一标识
      let currentChunk = 0; // 当前上传的分片索引
      let uploadedBytes = 0; // 已上传的总字节数

      function uploadChunk () {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const data = file.slice(start, end);
        const formData = new FormData();
        formData.append("file", data, file.name);
        formData.append("label", "T006");
        formData.append("is_tmp", "1");
        formData.append("uuid", uuid);
        formData.append("chunks", totalChunks);
        formData.append("chunk", currentChunk);
        // 发送分片数据
        axios.post(`${services.HOST}/api/upload/file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const chunkUploadedBytes = progressEvent.loaded;
            uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
            // 更新上传进度
            let percent = Math.round((uploadedBytes / file.size) * 100);
            if (type == 1) {
              if (percent > that.coverImg.progress) {
                that.$set(that.coverImg, "progress", percent)
              }
            } else {
              let index = that.fileList.findIndex(item => item.fileTime == fileTime)
              if (index > -1 && percent > that.fileList[index].progress) {
                that.fileList[index].progress = Math.round((uploadedBytes / file.size) * 100);
              }
            }
          }
        }).then(({ data: result }) => {
          if (currentChunk < totalChunks - 1) {
            // 继续上传下一片
            currentChunk++;
            uploadChunk();
          } else {
            if (result.code == "0000") {
              that.$message.success(result.message)
              if (type == 1) {
                that.$set(that.coverImg, "status", 'success')
                that.$set(that.coverImg, "progress", '100')
                that.$set(that.coverImg, "view_url", result.data.url)
                that.$set(that.coverImg, "path", result.data.path)
                that.form.setFieldsValue({ cover: result.data.path })
              } else {
                let index = (that.fileList.findIndex(item => item.fileTime == fileTime))
                let vData = {
                  ...that.fileList[index],
                  progress: 100,
                  status: 'success',
                  view_url: result.data.url,
                  path: result.data.path
                }
                that.$set(that.fileList, index, vData)
                that.form.setFieldsValue({ cases_attachments: that.fileList })
              }
            } else {
              that.$message.error(result.message)
              if (type == 1) {
                that.removeCoverFile()
              } else {
                let index = (that.fileList.findIndex(item => item.fileTime == fileTime))
                that.removeVideoFile(index)
              }
            }

          }
        }).catch((error) => {
          console.error("上传失败", error);
        });
      }

      // 开始上传第一片
      uploadChunk();
    },
    // 视频上传
    handleVideoUpload (file, fileTime) {
      let that = this
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的文件`)

      const uploaderVideo = that.tcVods.upload({
        is_tmp: 1,
        mediaFile: file
      })

      // 监听上传进度
      uploaderVideo.on('media_progress', (name) => {
        let fileIndex = that.fileList.findIndex(item => item.fileTime == fileTime)
        let percent = parseInt(name.percent * 100)
        if (fileIndex > -1 && percent > that.fileList[fileIndex].progress) {
          that.$set(that.fileList[fileIndex], 'progress', parseInt(name.percent * 100));
        }
      })
      // 上传完成
      uploaderVideo.done().then(async doneResult => {
        let fileIndex = that.fileList.findIndex(item => item.fileTime == fileTime)
        if (fileIndex > -1) {
          let vData = {
            ...that.fileList[fileIndex],
            progress: 100,
            status: 'success',
            view_url: doneResult.video.url,
            path: doneResult.video.url,
            file_id: doneResult.fileId,
          }
          that.$set(that.fileList, fileIndex, vData)
          that.form.setFieldsValue({ cases_attachments: that.fileList })
        }
        await services.getTencentVodInfo({ file_id: doneResult.fileId }).then(checkRes => {
          console.log("checkRes", checkRes)
          if (checkRes.code == "0000" && checkRes.data) {
            // 判断视频大于100KB 状态正常 时长>0 
            if (checkRes.data.status != 'Normal' || checkRes.data.duration < 1 || checkRes.data.size < 102400) {
              that.uploadErrorVisible = true
              let fileIndex = that.fileList.findIndex(item => item.fileTime == fileTime)
              if (fileIndex > -1) that.removeVideoFile(fileIndex)
            }
          }
        })
        // 视频上传完成后固定调用腾讯云点播修改时长接口，设置为1天(86400ms)
        await services.setTencentTime({ FileId: doneResult.fileId, ExpireTime: 86400 })
      }).catch((err) => {
        let fileIndex = that.fileList.findIndex(item => item.fileTime == fileTime)
        this.$message.error(`上传失败：${err}`)
        if (fileIndex > -1) that.removeVideoFile(fileIndex)

      })
    },

    // 删除封面
    removeCoverFile () {
      this.coverImg = null
      this.form.setFieldsValue({ cover: undefined })
    },
    // 删除视频附件
    removeVideoFile (index) {
      this.fileList.splice(index, 1);
      this.form.setFieldsValue({ cases_attachments: this.fileList })
    },
    // 获取文件类型
    getFileType (fileType) {
      if (fileType.includes("image")) return "1";
      if (fileType.includes("video")) return "3";
    },
    // 预览资源
    previewRes (item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1 || item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
    // 预览案例弹窗
    previewCase () {
      let that = this
      this.previewObj = this.form.getFieldsValue()
      console.log("预览", this.previewObj)

      // 判断视频上传完成后再提交
      let isUploading = false
      for (let i = 0; i < that.fileList.length; i++) {
        if (that.fileList[i] && that.fileList[i].status == 'uploading') {
          isUploading = true
          break;  // 找到目标值后退出循环
        }
      }
      if (isUploading) return that.$message.info("请等待视频上传完成后再次预览")

      this.modalTitle = '预览'
      this.showModal = true

      if (that.previewObj.cases_attachments) {
        for (let i = 0; i <= that.previewObj.cases_attachments.length; i++) {
          if (that.previewObj.cases_attachments[i] && that.previewObj.cases_attachments[i].file_id && that.previewObj.cases_attachments[i].covert_status == 2) {
            that.$nextTick(() => {
              window.setTimeout(() => {
                that.initPlayer(`player-pc-${i}`, that.previewObj.cases_attachments[i].file_id, 'pc', i)
                that.initPlayer(`player-h5-${i}`, that.previewObj.cases_attachments[i].file_id, 'h5', i)
              }, 300);
            })
          }
        }
      }

    },
    // 关闭预览案例弹窗事件
    cancelShowModal () {
      this.showModal = false
      this.reviewTab = 'pc'
      for (let i = 0; i <= this.previewObj.cases_attachments.length; i++) {
        if (this.previewObj.cases_attachments[i] && this.previewObj.cases_attachments[i].file_id && this.previewObj.cases_attachments[i].covert_status == 2) {
          this['palyerpc' + i].dispose();
          this['palyerpc' + i] = null;
          this['palyerh5' + i].dispose();
          this['palyerh5' + i] = null;
        }
      }
    },
    // 初始化腾讯云播放器
    initPlayer (idDom, file_id, type, index) {
      let playName = 'palyer' + type + index
      this[playName] = window.TCPlayer(idDom, {
        width: type == 'pc' ? 464 : 290,
        height: type == 'pc' ? 261 : 163,
        fileID: file_id,
        appID: '1500004122',
        posterImage: true,
        bigPlayButton: true,
        autoplay: false,
        controlBar: {
          playbackRateMenuButton: true,
          QualitySwitcherMenuButton: false,
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-form .ant-input {
    color: #494e57;
}
/deep/ .ant-form .ant-input::placeholder {
    color: #939396;
}
/deep/ .ant-form-item-label > label {
    color: #373536;
}
/deep/ .ant-form .ant-form-item:last-child {
    margin-bottom: 10px;
}
.primary-box {
    padding: 10px 100px 0 0;
    width: 100%;
    box-sizing: border-box;
    .search-all-box {
        display: block;
        .file-handle {
            .upload-btn {
                width: 88px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
                background: #a82822;
                border-radius: 0;
                border: none;
                &:hover {
                    background: #a82822;
                }
            }
        }
        .upload-text {
            font-size: 14px;
            line-height: 1;
            color: #d88d45;
            margin: 10px 0;
        }
        .file-list {
            display: flex;
            padding-top: 16px;
            gap: 22px;
            flex-wrap: wrap;
            .file-item {
                position: relative;
                width: 220px;
                cursor: pointer;
                .file-upper {
                    width: 100%;
                    height: 124px;
                    aspect-ratio: 220/124;
                    position: relative;
                    overflow: hidden;
                    .file-cover {
                        width: 100%;
                        height: 100%;
                        transition: all 0.3s;
                        &.file-docx {
                            background: #e5ecfa;
                            &::before {
                                content: '';
                                display: inline-block;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 53px;
                                height: 63px;
                                background: url('../../../assets/image/student/unitTwo/file-word.png')
                                    no-repeat center/cover;
                            }
                        }
                    }
                    .file-delete {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 28px;
                        height: 28px;
                        background: rgba(255, 255, 255);
                        border-radius: 0px 0px 0px 14px;
                        border: 1px solid #cc9d9a;
                        transition: all 0.3s;
                        z-index: 2;
                        &::before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 7px;
                            left: 7px;
                            background: url('../../../assets/image/student/unitTwo/delete-red.png')
                                no-repeat center/cover;
                            width: 15px;
                            height: 15px;
                            transition: all 0.3s;
                        }
                    }
                    .file-button {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #ffffff;
                        z-index: 1;
                        opacity: 0;
                    }
                    .file-mask {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(60, 60, 62, 0.6);
                        transition: all 0.3s;
                        opacity: 0;
                    }
                    .file-progress {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                        /deep/ span {
                            font-weight: bold;
                            font-size: 12px;
                            color: #a82822;
                        }
                        /deep/ .ant-progress-inner {
                            background: #fff;
                        }
                    }
                    .file-translate {
                        width: 100%;
                        height: calc(100% + 2px);
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                        background: url('../../../assets/image/school/common/success.jpg')
                            no-repeat center/cover;
                        &.translate {
                            background: url('../../../assets/image/student/unitTwo/translate.png')
                                no-repeat center/cover;
                        }
                        &.transerror {
                            background: url('../../../assets/image/student/unitTwo/transerror.jpg')
                                no-repeat center/cover;
                        }
                    }
                }
                .file-name {
                    height: 62px;
                    background: #ffffff;
                    // border: 1px solid #e7eaec;
                    font-size: 14px;
                    color: #3c3c3e;
                    padding: 9px 0 0;
                    .name-txt {
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        height: 40px;
                        line-height: 20px;
                    }
                }
                &:hover {
                    .file-upper {
                        .file-cover {
                            transform: scale(1.1);
                        }
                        .file-docx {
                            transform: scale(1) !important;
                        }
                        .file-delete {
                            background: linear-gradient(
                                90deg,
                                #c0403a 3%,
                                #bb1c15 100%
                            );
                            border: 1px solid #cc9d9a;
                            opacity: 0.94;
                            &::before {
                                background: url('../../../assets/image/student/unitTwo/delete-white.png')
                                    no-repeat center/cover;
                            }
                        }
                        .file-mask {
                            opacity: 1;
                        }
                        .file-button {
                            opacity: 1;
                        }
                    }
                }
                // 转码中
                &.translate {
                    .file-mask {
                        opacity: 0;
                    }

                    &:hover {
                        .file-mask {
                            opacity: 1;
                        }
                    }
                }
                &.uploading {
                    .file-upper {
                        .file-mask {
                            opacity: 1;
                        }
                    }
                }
            }
        }
        .group-box {
            width: 100%;
            text-align: center;
            padding-top: 30px;
            .btn-item {
                cursor: pointer;
                font-size: 14px;
                color: #ffffff;
                line-height: 32px;
                text-indent: 3px;
                letter-spacing: 3px;
                width: 76px;
                height: 32px;
                text-align: center;
                background: #ecedef;
                display: inline-block;
                margin: 0 7px;
                &.cancel {
                    background: #ecedef;
                    color: #333333;
                    &:hover {
                        background: #e3e5e8;
                    }
                }
                &.submit {
                    background: #a82822;
                    &:hover {
                        background: #a82822;
                    }
                }
                &.preview {
                    background: #b84b3c;
                    &:hover {
                        background: #a82822;
                    }
                }
            }
        }
    }
}

.case-content-box {
    width: 1000px;
    display: flex;
    padding: 20px 0 0;
    .review-tabs {
        width: 162px;
        margin-right: 45px;
        .tabs-item {
            width: 100%;
            height: 38px;
            background: #f0f2f4;
            border-radius: 19px 0px 0px 19px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            color: #111111;
            cursor: pointer;
            margin-bottom: 10px;
            &.active {
                background: #c33936;
                color: #ffffff;
            }
        }
    }
    .right-all-box {
        width: 790px;
        .case-title {
            font-size: 22px;
            color: #191919;
            line-height: 34px;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #e7e9f1;
            margin-bottom: 20px;
        }
        .case-info {
            display: flex;
            align-items: baseline;
            margin-bottom: 10px;
            .info-label {
                font-weight: bold;
                font-size: 14px;
                color: #373536;
                width: 70px;
            }
            .info-con {
                flex: 1;
                font-weight: 400;
                font-size: 14px;
                color: #494e57;
                span {
                    display: inline-block;
                    padding: 3px 14px;
                    text-align: center;
                    background: #f4f3f3;
                    border-radius: 14px;
                    margin-right: 10px;
                    margin-bottom: 5px;
                }
            }
        }
        .case-video-box {
            padding-bottom: 20px;
            border-bottom: 1px solid #e7e9f1;
            margin-bottom: 20px;
            .video-items {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 10px;
                .trans-cover img {
                    width: 464px;
                    height: auto;
                }
            }
        }
        .content-txt {
            padding: 0 !important;
            p {
                font-size: 14px;
                color: #5c5f6b;
                line-height: 26px;
                text-indent: 2rem;
            }
            p:has(img, audio, video) {
                text-align: center;
                text-indent: 0 !important;
            }
            /deep/ img {
                max-width: 90%;
                height: auto;
                display: block;
                margin: 5px auto;
            }
            /deep/ ul {
                margin: inherit;
                // padding: 0;
            }
            /deep/ ol {
                margin: inherit;
                // padding: 0;
            }
            /deep/ a {
                color: #06c;
                text-decoration: underline;
            }
        }

        .outer-h5 {
            width: 790px;
            .video-items {
                width: 100%;
                .trans-cover img {
                    width: 290px;
                    height: auto;
                }
            }
        }
        .platform-h5 {
            width: 360px;
            height: 635px;
            aspect-ratio: 612 / 1080;
            margin: 0 auto 0;
            background: url(../../../assets/image/school/common/mobile.png)
                no-repeat center / cover;
            padding: 36px 32px 10px;
            min-width: 250px;
            // transform: scale(0.9);
            // transform-origin: 0 0;
            .h5-scroll {
                scrollbar-width: none;
                width: 100%;
                height: 100%;
                overflow-y: auto;
                border-radius: 24px 24px 0 0;
                background: #fff;
                padding: 32px 0;
                .case-title {
                    font-size: 18px;
                    line-height: 30px;
                    padding-bottom: 20px;
                    border-bottom: 1px solid #e7e9f1;
                    margin-bottom: 20px;
                }
                .case-info {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 8px;
                    .info-label {
                        font-size: 13px;
                        width: 65px;
                    }
                    .info-con {
                        font-size: 12px;
                        span {
                            padding: 2px 8px;
                            border-radius: 10px;
                            margin-right: 5px;
                        }
                    }
                }
                .case-video-box {
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e7e9f1;
                    margin-bottom: 10px;
                }
                .content-txt {
                    /deep/ img {
                        max-width: 90%;
                    }
                    p {
                        font-size: 12px;
                        color: #5c5f6b;
                        line-height: 24px;
                        text-indent: 2rem;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 1500px) {
    .primary-box {
        padding: 10px 10px 0 0;
    }
}
</style>